import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag-vertical",
  "use": "drag-vertical-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drag-vertical\"><path d=\"M8 6h3v4h2V6h3l-4-4zm8 12h-3v-4h-2v4H8l4 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol